function toggleModal(id, show) {
	const dialog = document.getElementById(id)

	if (show || !dialog.open) {
		dialog.showModal()
	} else {
		dialog.close()
	}
}

document.querySelectorAll('.modal__button').forEach((button) => {
	button.addEventListener('click', () => {
		toggleModal(button.dataset.modalId)
	})
})

document
	.querySelectorAll('.modal:not(.modal--no-listeners) .modal__close')
	.forEach((button) => {
		button.addEventListener('click', () => {
			const dialog = button.closest('.modal')
			toggleModal(dialog.id, false)
		})
	})

document
	.querySelectorAll('.modal:not(.modal--no-listeners)')
	.forEach((modal) => {
		modal.addEventListener('click', (event) => {
			if (event.target === modal) {
				modal.close()
			}
		})
	})
